import UserExplorerState from '../interfaces/states/UserExplorerState';

import * as Const from '../constants';

const initState: UserExplorerState = {
  isLoading: false,
  isError: false,
  userExplorerData: {
    data: {
      event: [],
    },
  },
  current: {
    currentCategory: null,
    currentLabel: null,
  },
  /*
  @TODO Remove 'All' in common prop state / rewrite categories from './utils/userExplorerTable/'  using the reduce method
     */
  currentCategory: {
    LandViewerEvents: false,
    VisionEvents: false,
    AuthEvents: false,
    AgroEvents: false,
    StorageEvents: false,
    All: true,
  },
};

export default function userExplorer (state: UserExplorerState = initState, action): UserExplorerState {
  switch (action.type) {

    case Const.FETCH_USER_EXPLORER_INIT:
      return {
        ...initState,
      };

    case Const.FETCH_USER_EXPLORER_PENDING:
      return {
        ...state,
        isLoading: true,
        isError: false,
      };

    case Const.FETCH_USER_EXPLORER_ERROR:
      return {
        ...state,
        isError: true,
        isLoading: false,
      };

    case Const.FETCH_USER_EXPLORER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isError: false,
        userExplorerData: action.payload,
      };

    case Const.FETCH_USER_EXPLORER_CURRENT_EVENT:
      return {
        ...state,
        isLoading: false,
        isError: false,
        current: {
          ...state.current,
          currentCategory: action.category,
          currentLabel: action.label,
        },
      };

    case Const.FETCH_USER_EXPLORER_CHANGE_CATEGORY:
      return {
        ...state,
        currentCategory: {
          ...state.currentCategory,
          [action.category]: action.checked,
        },
      };

    default:
      return state;
  }
}
